<template>
    <module-card :nextDisabled="nextDisabled" ref="moduleCard">
        <p>So, now back to P and Rodney... Putting this all together, what/how would you advise P to say/act get what he wants?</p>
        <div v-for="choice in choices" :key="choice.id" @click.stop="select(choice)" class="grey pa-3 mb-1 response" :class="{ 'lighten-3': !isSelected(choice) }" v-ripple>
            <span :class="{ 'incorrect-selected': isIncorrectAlreadySelected(choice) }">{{ choice.text }}</span>
        </div>
        <slot></slot>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                incorrectSelected: [],
                choices: [
                    {
                        id: 1,
                        text: 'Look Rodney in the eyes and let him know that hot sex is safer sex - with a condom – then there’s no worries about who’s done what before.',
                        correct: true,
                        message: 'That’s correct!'
                    },
                    {
                        id: 2,
                        text: 'Get up in Rodney’s face and tell him where he can go if he wants to have sex without a condom.',
                        correct: false,
                        message:
                            'Well... this would be an “aggressive” rather than “assertive” response. An aggressive response is an active but ineffective response. P might maintain his bottom line with this response, but also undermine his relationship with Rodney, which he doesn’t want to do. Try another response.'
                    },
                    {
                        id: 3,
                        text: 'Agree to have sex without a condom because he’s really horny and doesn’t want to piss Rodney off.',
                        correct: false,
                        message:
                            'Well... this would be a “passive” response. Passive communication is inactive or ineffective in communicating what you want. With this response, Pavoids conflict with Rodney, but gives up his BottomLine. He’ll probably feel really bad about it too and not feel like the sex is hot! The consequences for P might be more than just feeling bad, like getting an STI from Rodney or giving him one. Try another response.'
                    }
                ],
                selectedChoice: null
            };
        },
        methods: {
            nextDisabled() {
                if (this.selectedChoice && this.selectedChoice.correct) {
                    return false;
                }

                return true;
            },
            select(choice) {
                if (choice.correct) {
                    this.$refs.modalFeedback.show(true, choice.message, () => {
                        this.selectedChoice = choice;
                        this.$refs.moduleCard.nextClick();
                    });
                } else {
                    this.$refs.modalFeedback.show(false, choice.message, () => {
                        this.incorrectSelected.push(choice.id);
                    });
                }
            },
            isSelected(choice) {
                return choice === this.selectedChoice;
            },
            isIncorrectAlreadySelected(choice) {
                return this.incorrectSelected.includes(choice.id);
            }
        }
    };
</script>

<style scoped>
    .incorrect-selected {
        text-decoration: line-through;
        text-decoration-color: red;
    }
</style>
